import { GroupList } from '@thehubz/client/core';

export const DownloadPurposeData: GroupList = {
  lists: [
    { _id: 'print', name: $localize`:download-purpose:Print`, description: '' },
    { _id: 'digital', name: $localize`:download-purpose:Digital`, description: '' },
    { _id: 'sozial.media', name: $localize`:download-purpose:Social Media`, description: '' },
    { _id: 'mobile', name: $localize`:download-purpose:Mobile`, description: '' },
    { _id: 'tv', name: 'TV', description: '' },
    { _id: 'event', name: $localize`:download-purpose:Event`, description: '' },
    { _id: 'training', name: $localize`:download-purpose:Training`, description: '' },
    { _id: 'ooh', name: 'OOH', description: '' },
    { _id: 'presentation', name: $localize`:download-purpose:Presentation`, description: '' },
  ],
  name: $localize`Purpose`,
};

export const SelectFileOptions = [
  { _id: 'main', name: $localize`Original`, fieldSelected: true },
  { _id: 'gen-midres', name: $localize`Medium resolution` },
  { _id: 'gen-lowres', name: $localize`Low resolution` },
];
